import React from "react";
import {
    Navigate,
} from "react-router-dom";

const OrderListComponent = React.lazy(() => import("../../../../../components/purchase-order/components/list/page"));
const OrderAddComponent = React.lazy(() => import("../../../../../components/purchase-order/components/add/page"));

export const ordersRoute = [
    {
        path: 'list',
        element: <OrderListComponent />
    },
    {
        path: 'add',
        element: <OrderAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/stockify/orders/add" />
    },
    {
        path: 'edit/:id',
        element: <OrderAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/stockify/orders/list" />
    },
];